(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fm-direct-signup-inline"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(form) {
    if (form.dataset.fmInit === '1') return;
    form.dataset.fmInit = '1';

    var publicKey = form.dataset.klaviyoPublicKey;
    var listId = form.dataset.klaviyoListId;
    var source = form.dataset.source || 'FirstMark Hero Inline';
    var emailInput = form.querySelector('.fm-signup-inline__input');
    var errorMsg = form.querySelector('.fm-signup-inline__msg--error');
    var successMsg = form.querySelector('.fm-signup-inline__msg--success');

    function showError(text) {
      errorMsg.textContent = text;
      errorMsg.hidden = false;
      successMsg.hidden = true;
    }
    function clearError() {
      errorMsg.hidden = true;
      errorMsg.textContent = '';
    }
    function showSuccess() {
      form.classList.add('is-submitted');
      successMsg.hidden = false;
      errorMsg.hidden = true;
      try {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'fm_signup_success', form_source: source, list_id: listId });
        }
      } catch (e) {}
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      clearError();
      var email = (emailInput.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      form.classList.add('is-loading');
      var btn = form.querySelector('.fm-signup-inline__btn');
      btn.disabled = true;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function(res) {
        form.classList.remove('is-loading');
        btn.disabled = false;
        if (res.status === 202 || res.status === 200 || res.status === 201) {
          showSuccess();
        } else {
          return res.json().then(function(j) {
            var msg = 'Something went wrong. Please try again.';
            if (j && j.errors && j.errors[0] && j.errors[0].detail) msg = j.errors[0].detail;
            showError(msg);
          }).catch(function() {
            showError('Something went wrong. Please try again.');
          });
        }
      }).catch(function() {
        form.classList.remove('is-loading');
        btn.disabled = false;
        showError('Network error. Please try again.');
      });
    });
  }

  function boot() {
    document.querySelectorAll('.fm-signup-inline__form').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-direct-signup"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(form) {
    if (form.dataset.fmInit === '1') return;
    form.dataset.fmInit = '1';

    var publicKey = form.dataset.klaviyoPublicKey;
    var listId = form.dataset.klaviyoListId;
    var source = form.dataset.source || 'FirstMark Site Form';
    var emailInput = form.querySelector('.fm-signup__input');
    var errorMsg = form.querySelector('.fm-signup__msg--error');
    var successMsg = form.querySelector('.fm-signup__msg--success');

    function showError(text) {
      errorMsg.textContent = text;
      errorMsg.hidden = false;
      successMsg.hidden = true;
    }
    function clearError() {
      errorMsg.hidden = true;
      errorMsg.textContent = '';
    }
    function showSuccess() {
      form.classList.add('is-submitted');
      successMsg.hidden = false;
      errorMsg.hidden = true;
      try {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'fm_signup_success', form_source: source, list_id: listId });
        }
      } catch (e) {}
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      clearError();
      var email = (emailInput.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      form.classList.add('is-loading');
      var btn = form.querySelector('.fm-signup__btn');
      btn.disabled = true;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      }).then(function(res) {
        form.classList.remove('is-loading');
        btn.disabled = false;
        if (res.status === 202 || res.status === 200 || res.status === 201) {
          showSuccess();
        } else {
          return res.json().then(function(j) {
            var msg = 'Something went wrong. Please try again.';
            if (j && j.errors && j.errors[0] && j.errors[0].detail) {
              msg = j.errors[0].detail;
            }
            showError(msg);
          }).catch(function() {
            showError('Something went wrong. Please try again.');
          });
        }
      }).catch(function() {
        form.classList.remove('is-loading');
        btn.disabled = false;
        showError('Network error. Please check your connection and try again.');
      });
    });
  }

  function boot() {
    document.querySelectorAll('.fm-signup__form').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init for Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
